import { Input, InputProps } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useDebouncedCallback } from 'use-debounce'

/**
 * simple controlled input and it's value. Useful when you don't need a form, but you are too lazy to to write your own event handlers for the input
 */
export const useInput = (props?: InputProps) => {
  const [value, setValue] = useState<string>('')
  const input = (
    <Input
      value={value}
      onChange={(e) => setValue(e.target.value)}
      type="text"
      {...props}
    />
  )
  return [value, input] as [string, JSX.Element]
}
/**
 * same as the previous component, but with a debounce in the mix
 */
export const useDebouncedInput = (
  props: InputProps & { debounce?: number; As?: any }
) => {
  const [value, setValue] = useState<string>('')

  const debounced = useDebouncedCallback((value) => {
    setValue(value)
  }, props?.debounce || 1000)

  let input: JSX.Element

  const { As } = props
  if (As) {
    input = (
      <As
        defaultValue={value}
        onChange={(e) => debounced(e.target.value)}
        type="text"
        {...props}
      />
    )
  } else {
    input = (
      <Input
        defaultValue={value}
        onChange={(e) => debounced(e.target.value)}
        type="text"
        {...props}
      />
    )
  }

  return [value, input] as [string, JSX.Element]
}
